export default "__VITE_ASSET__01c52d5d__"